<template>
    <div class="login-body">
        <div class="login-container">
            <div class="login-form">
                <div class="login-form-logo">
                    <img src="/LOGO1_FULL.png" />
                </div>
                <b-form @submit.prevent="doLogin">
                    <h5>Log In</h5>
                    <b-form-group label="Username">
                        <b-form-input
                            v-model="input.username"
                            placeholder="username"
                            required
                        />
                    </b-form-group>
                    <b-form-group label="Password" class="password-form-group">
                        <b-form-input
                            v-model="input.password"
                            placeholder="password"
                            :type="passwordType"
                            required
                        />
                        <!-- <i :class="iconName" @click="changePasswordType()" /> -->
                    </b-form-group>
                    <b-button
                        type="submit"
                        block
                        variant="primary"
                        :disabled="isLoggingIn"
                    >
                        {{ isLoggingIn ? "Logging in..." : "Log In" }}
                    </b-button>
                    <div
                        class="login-error-wrapper mt-3"
                        v-if="errorMessage != ''"
                    >
                        <div class="text-danger">{{ errorMessage }}</div>
                    </div>
                </b-form>
                <p class="login-copyright">&copy; 2023 Sinar Mutiara Cell</p>
            </div>
            <div class="login-content">
                <div class="login-content-wrapper">
                    <div class="login-sm-hidecontent">
                        <h1>Selamat Datang!</h1>
                        <p>DEV - Sinar Mutiara Ecommerce Panel</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "Login",
    data() {
        return {
            input: {
                username: "",
                password: "",
            },

            isLoggingIn: false,
            errorMessage: "",

            passwordType: "password",
            iconName: "fa fa-eye-slash",
            oldPasswordType: "password",
            oldIconName: "fa fa-eye-slash",
            newPasswordType: "password",
            newIconName: "fa fa-eye-slash",
            confirmPasswordType: "password",
            confirmIconName: "fa fa-eye-slash",
        };
    },
    methods: {
        doLogin() {
            let payload = new FormData();
            payload.append("username", this.input.username);
            payload.append("password", this.input.password);

            this.isLoggingIn = true;
            this.errorMessage = "";
            this.$axios
                .post(`loginAdmin`, payload)
                .then((response) => {
                    let data = response.data.data;

                    // let currentVersion = localStorage.getItem("version")
                    // if(currentVersion === null || currentVersion !== data.version) {
                    //     localStorage.setItem("reload", 1)
                    //     localStorage.setItem("version", data.version)
                    // }

                    localStorage.setItem("version", "v0.1");
                    localStorage.setItem("token", data.token);
                    localStorage.setItem("username", data.username);
                    localStorage.setItem("fullname", data.nama);
                    localStorage.setItem("roleId", data.role_id);
                    localStorage.setItem("userId", data.userId);
                    localStorage.setItem(
                        "roleName",
                        data.role_id == 1 ? "Superadmin" : "Admin"
                    );
                    // localStorage.setItem("loginTime", data.loginTime)

                    this.$axios.defaults.headers.common["Authorization"] =
                        localStorage.getItem("token");
                    // this.$axios.defaults.headers.common['LoginTime'] = localStorage.getItem('loginTime')
                    this.$router.push("/order");
                })
                .catch((error) => {
                    this.$helper.toastError(this, error.response.data.error);
                })
                .finally(() => {
                    this.isLoggingIn = false;
                });
        },

        // changePasswordType() {

        //     if(this.passwordType == 'password' && this.iconName == 'fa fa-eye-slash') {
        //         this.passwordType = 'text'
        //         this.iconName = 'fa fa-eye'
        //     }
        //     else {
        //         this.passwordType = 'password'
        //         this.iconName = 'fa fa-eye-slash'
        //     }

        // },
    },
    created() {
        if (this.$route.query.error) {
            this.$helper.toastError(this, "Anda sudah login di device lain");
        }
    },
};
</script>
